function password(value: string): boolean {
  const regexPassword =
    /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/g;

  const isValuePassword = regexPassword.test(value);

  return isValuePassword;
}

export default password;
